export default function Todoskeleton() {
  return (
    <div className=" w-full animate-pulse flex mb-1 bg-[#bf99f0]  relative transition-transform duration-300 transform hover:scale-[102%] items-center p-2 justify-between rounded-md bg-slate-200  bg-gray-900">
      <span className="h-4 w-1/2 bg-gray-400 rounded-full dark:bg-gray-700"></span>
      <span className="bg-gray-400 h-4 w-[30px] rounded-full"></span>
    </div>
  );
}
